/**
 * The different API environments that may be set when signing in
 */
export enum ApiEnvironment {
    Prod = 'prod',
    Test = 'test',
    Dev = 'dev',
    Custom = 'custom'
}
